import { MedallionBanner } from '@com-delta-omnichannel/aura';
import { Menu } from '../../../features';

export interface LandingPage {
  medallionBanner: MedallionBanner;
  menu: Menu;
}
